"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBundleControllerAvailableBundleSplits = exports.getBundleControllerAvailableBundleSplitsQueryKey = exports.bundleControllerAvailableBundleSplits = exports.useBundleControllerCancelBundle = exports.bundleControllerCancelBundle = exports.useBundleControllerBuyBundle = exports.bundleControllerBuyBundle = exports.useBundleControllerGetMyTrades = exports.getBundleControllerGetMyTradesQueryKey = exports.bundleControllerGetMyTrades = exports.useBundleControllerCreateBundle = exports.bundleControllerCreateBundle = exports.useBundleControllerGetMyBundles = exports.getBundleControllerGetMyBundlesQueryKey = exports.bundleControllerGetMyBundles = exports.useBundleControllerGetAvailableBundles = exports.getBundleControllerGetAvailableBundlesQueryKey = exports.bundleControllerGetAvailableBundles = void 0;
/**
 * Generated by orval v6.5.1 🍺
 * Do not edit manually.
 * Exchange API
 * Swagger documentation for the Exchange API
 * OpenAPI spec version: 0.1
 */
const react_query_1 = require("react-query");
const response_type_1 = __importDefault(require("../response-type"));
const response_type_2 = __importDefault(require("../response-type"));
const response_type_3 = __importDefault(require("../response-type"));
const response_type_4 = __importDefault(require("../response-type"));
const response_type_5 = __importDefault(require("../response-type"));
const response_type_6 = __importDefault(require("../response-type"));
const response_type_7 = __importDefault(require("../response-type"));
const bundleControllerGetAvailableBundles = () => {
    return (0, response_type_1.default)({ url: `/api/bundle/available`, method: 'get'
    });
};
exports.bundleControllerGetAvailableBundles = bundleControllerGetAvailableBundles;
const getBundleControllerGetAvailableBundlesQueryKey = () => [`/api/bundle/available`];
exports.getBundleControllerGetAvailableBundlesQueryKey = getBundleControllerGetAvailableBundlesQueryKey;
const useBundleControllerGetAvailableBundles = (options) => {
    var _a;
    const { query: queryOptions } = options || {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getBundleControllerGetAvailableBundlesQueryKey)();
    const queryFn = () => (0, exports.bundleControllerGetAvailableBundles)();
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, queryOptions);
    return Object.assign({ queryKey }, query);
};
exports.useBundleControllerGetAvailableBundles = useBundleControllerGetAvailableBundles;
const bundleControllerGetMyBundles = () => {
    return (0, response_type_2.default)({ url: `/api/bundle`, method: 'get'
    });
};
exports.bundleControllerGetMyBundles = bundleControllerGetMyBundles;
const getBundleControllerGetMyBundlesQueryKey = () => [`/api/bundle`];
exports.getBundleControllerGetMyBundlesQueryKey = getBundleControllerGetMyBundlesQueryKey;
const useBundleControllerGetMyBundles = (options) => {
    var _a;
    const { query: queryOptions } = options || {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getBundleControllerGetMyBundlesQueryKey)();
    const queryFn = () => (0, exports.bundleControllerGetMyBundles)();
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, queryOptions);
    return Object.assign({ queryKey }, query);
};
exports.useBundleControllerGetMyBundles = useBundleControllerGetMyBundles;
const bundleControllerCreateBundle = (createBundleDTO) => {
    return (0, response_type_3.default)({ url: `/api/bundle`, method: 'post',
        data: createBundleDTO
    });
};
exports.bundleControllerCreateBundle = bundleControllerCreateBundle;
const useBundleControllerCreateBundle = (options) => {
    const { mutation: mutationOptions } = options || {};
    const mutationFn = (props) => {
        const { data } = props || {};
        return (0, exports.bundleControllerCreateBundle)(data);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useBundleControllerCreateBundle = useBundleControllerCreateBundle;
const bundleControllerGetMyTrades = () => {
    return (0, response_type_4.default)({ url: `/api/bundle/trade`, method: 'get'
    });
};
exports.bundleControllerGetMyTrades = bundleControllerGetMyTrades;
const getBundleControllerGetMyTradesQueryKey = () => [`/api/bundle/trade`];
exports.getBundleControllerGetMyTradesQueryKey = getBundleControllerGetMyTradesQueryKey;
const useBundleControllerGetMyTrades = (options) => {
    var _a;
    const { query: queryOptions } = options || {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getBundleControllerGetMyTradesQueryKey)();
    const queryFn = () => (0, exports.bundleControllerGetMyTrades)();
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, queryOptions);
    return Object.assign({ queryKey }, query);
};
exports.useBundleControllerGetMyTrades = useBundleControllerGetMyTrades;
const bundleControllerBuyBundle = (buyBundleDTO) => {
    return (0, response_type_5.default)({ url: `/api/bundle/buy`, method: 'put',
        data: buyBundleDTO
    });
};
exports.bundleControllerBuyBundle = bundleControllerBuyBundle;
const useBundleControllerBuyBundle = (options) => {
    const { mutation: mutationOptions } = options || {};
    const mutationFn = (props) => {
        const { data } = props || {};
        return (0, exports.bundleControllerBuyBundle)(data);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useBundleControllerBuyBundle = useBundleControllerBuyBundle;
const bundleControllerCancelBundle = (id) => {
    return (0, response_type_6.default)({ url: `/api/bundle/${id}/cancel`, method: 'put'
    });
};
exports.bundleControllerCancelBundle = bundleControllerCancelBundle;
const useBundleControllerCancelBundle = (options) => {
    const { mutation: mutationOptions } = options || {};
    const mutationFn = (props) => {
        const { id } = props || {};
        return (0, exports.bundleControllerCancelBundle)(id);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useBundleControllerCancelBundle = useBundleControllerCancelBundle;
const bundleControllerAvailableBundleSplits = (id) => {
    return (0, response_type_7.default)({ url: `/api/bundle/${id}/splits`, method: 'get'
    });
};
exports.bundleControllerAvailableBundleSplits = bundleControllerAvailableBundleSplits;
const getBundleControllerAvailableBundleSplitsQueryKey = (id) => [`/api/bundle/${id}/splits`];
exports.getBundleControllerAvailableBundleSplitsQueryKey = getBundleControllerAvailableBundleSplitsQueryKey;
const useBundleControllerAvailableBundleSplits = (id, options) => {
    var _a;
    const { query: queryOptions } = options || {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getBundleControllerAvailableBundleSplitsQueryKey)(id);
    const queryFn = () => (0, exports.bundleControllerAvailableBundleSplits)(id);
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(id) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useBundleControllerAvailableBundleSplits = useBundleControllerAvailableBundleSplits;
//# sourceMappingURL=bundle.js.map